import { render, staticRenderFns } from "./Circles.vue?vue&type=template&id=27906f76&scoped=true&"
import script from "./Circles.vue?vue&type=script&lang=js&"
export * from "./Circles.vue?vue&type=script&lang=js&"
import style0 from "./Circles.vue?vue&type=style&index=0&id=27906f76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27906f76",
  null
  
)

export default component.exports